import ImportACHPage from "components/pages/ImportACHPage";

/**
 * @name CaptureParticipantsAndNACHA
 * @returns {React.Component}
 * @description 
 * This capture is used in the following capture groups:
 * "ACH Import File (Participants)" (abi22).
 */
export default function CaptureParticipantsAndNACHA(props) {
    return <ImportACHPage/>;
}